module.exports = __webpack_public_path__ + "img/type-moped.5e50479f.svg";